import { createSelector } from "../reselect";
import { getNewStats, total, simpleChart, safeDivide, simpleChart2 } from "../generalUtils";

const providerId = "shipbob";

const shipbobOrders = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "orders")
);

const shipbobOrdersChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "orders")
);

const shipbobOrdersFulfilled = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "orders_fulfilled")
);

const shipbobOrdersFulfilledChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "orders_fulfilled")
);

const shipbobOrdersFulfilledOnTime = createSelector(
  [getNewStats],
  (stats) => total(stats[providerId], "orders_fulfilled_on_time")
);
const shipbobOrdersFulfilledOnTimeChart = createSelector(
  [getNewStats],
  (stats) => simpleChart(stats[providerId], "orders_fulfilled_on_time")
);

const shipbobPercentOfOrdersFulfilledOnTime = createSelector(
  [shipbobOrdersFulfilledOnTime, shipbobOrdersFulfilled],
  (shipbobOrdersFulfilledOnTime, shipbobOrdersFulfilled) => {
    return safeDivide(shipbobOrdersFulfilledOnTime, shipbobOrdersFulfilled) * 100;
  }
);
const shipbobPercentOfOrdersFulfilledOnTimeChart = createSelector(
  [shipbobOrdersFulfilledOnTimeChart, shipbobOrdersFulfilledChart],
  (shipbobOrdersFulfilledOnTimeChart, shipbobOrdersFulfilledChart) =>
    simpleChart2(shipbobOrdersFulfilledOnTimeChart, shipbobOrdersFulfilledChart, {chart1yMultiplier:100})
);

const shipbobFulfillmentCost = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "fulfillment_cost")
);

const shipbobFulfillmentCostChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "fulfillment_cost")
);

const shipbobAvgFulfillmentCost = createSelector(
  [shipbobFulfillmentCost, shipbobOrdersFulfilled],
  (shipbobFulfillmentCost, shipbobOrdersFulfilled) => {
    return safeDivide(shipbobFulfillmentCost, shipbobOrdersFulfilled);
  }
);

const shipbobAvgFulfillmentCostChart = createSelector(
  [shipbobFulfillmentCostChart, shipbobOrdersFulfilledChart],
  (shipbobFulfillmentCostChart, shipbobOrdersFulfilledChart) => {
    return simpleChart2(shipbobFulfillmentCostChart, shipbobOrdersFulfilledChart)
  });

const shipbobEstimation = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'estimation')
);
const shipbobEstimationChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'estimation')
);

const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    shipbobOrders,
    shipbobOrdersChart,

    shipbobOrdersFulfilled,
    shipbobOrdersFulfilledChart,

    shipbobPercentOfOrdersFulfilledOnTime,
    shipbobPercentOfOrdersFulfilledOnTimeChart,

    shipbobFulfillmentCost,
    shipbobFulfillmentCostChart,

    shipbobAvgFulfillmentCost,
    shipbobAvgFulfillmentCostChart,

    shipbobEstimation,
    shipbobEstimationChart,
  },
};
